<template>
  <div style="width: 100%; height: 100%">
    <ShareModal :project="project" />
    <span>
      <div v-if="project.hash || meetingId" class="fullSize">
        <div class="row fullSize">
          <div class="request-user-wrapper" v-if="Object.keys(requestAuthUsers).length && isConnected">
            <div v-for="user in Object.values(requestAuthUsers)" :key="user.email" class="request-user-block">
              <div class="request-user-name">{{ user.email }} {{ 'asking to join' | i18n }}</div>
              <div v-if="requestAuthUsersLoading[user.email]" class="request-loader">
                <Loader />
              </div>
              <div class="request-user-buttons" v-else>
                <b-button size="sm" variant="primary" style="margin-right: 10px" @click="() => declineUser(user)">
                  {{ 'Decline' | i18n }}
                </b-button>
                <b-button size="sm" variant="outline-primary" @click="() => acceptUser(user)">{{ 'Accept' | i18n }}</b-button>
              </div>
            </div>
          </div>
          <div v-if="project.hash || meetingHash" :class="`col-${colomns.video} cammeras-wrapper`">
            <div id="main-camera" class="main-camera">
              <Video
                :hash="project.hash"
                :meetingHash="meetingHash"
                :colomns="colomns"
                :setActiveRoom="setActiveRoom"
                :leaveRoomIfJoined="leaveRoomIfJoined"
                :triggerWindow="triggerWindow"
                :id="id"
                :messageCount="messageCount"
                :setMessageCount="setMessageCount"
              />
            </div>
          </div>
          <div v-else class="loading-box">
            <span v-if="waitingForAccess">Waiting for access...</span>
            <Loader v-else />
          </div>
          <div :class="`col-${colomns.project} project-wrapper`" v-show="colomns.project">
            <Project
              :zoomProject="zoomProject"
              :colomns="colomns"
              :triggerWindow="triggerWindow"
              :connection="connection"
              :isConnected="isConnected"
              :setIsConnected="setIsConnected"
              :setConnection="setConnection"
              :setRequestAuthUsers="setRequestAuthUsers"
              :requestAuthUsers="requestAuthUsers"
              :requestAuthUsersLoading="requestAuthUsersLoading"
              :setRequestAuthUsersLoading="setRequestAuthUsersLoading"
              :project="project"
              :meetingId="meetingId"
              :setMeetingHash="setMeetingHash"
              :languages="languages"
              :setWaitingForAccess="setWaitingForAccess"
            />
          </div>
          <div :class="`col-${colomns.chat} chat-wrapper`" v-show="colomns.chat">
            <Chat
              :hash="project.hash || meetingHash"
              :languages="languages"
              :colomns="colomns"
              :triggerWindow="triggerWindow"
              :mainSize="mainSize"
              :addMessageCount="addMessageCount"
            />
          </div>
        </div>
      </div>
      <Loader v-else />
    </span>
  </div>
</template>

<script>
import api from '../../../../../api';

import Video from './video';
import Chat from './chat';
import Project from './project-details';
import PageHeader from '../../../../common/page-header';
import Loader from '../../../../common/loader';
import GoBack from '../../../../../../components/go-back';
import { NotificationMixin, AuthMixin, ProjectsMixin } from '../../../../../../mixins';
import { WS_TYPES, TRANSLATE_LANGUAGE } from '../../../../../../../../../constants';
import ShareModal from './share-modal.vue';

export default {
  name: 'App',
  components: {
    Video,
    PageHeader,
    Loader,
    Chat,
    ShareModal,
    GoBack,
    Project,
  },
  mixins: [ProjectsMixin, NotificationMixin, AuthMixin],
  beforeRouteLeave(to, from, next) {
    this.leaveRoomIfJoined();
    setTimeout(() => {
      window.location.reload(false);
    }, 1000);
    return next();
  },
  props: {
    leaveRoomIfJoined: {
      type: Function,
      default: () => {},
    },
    setActiveRoom: {
      type: Function,
      default: () => {},
    },
    activeRoom: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      id: null,
      meetingId: null,
      meetingHash: null,
      waitingForAccess: false,
      connection: null,
      isConnected: false,
      mode: 'chat',
      project: {},
      languages: [],
      output: null,
      isMobile: false,
      selectedCamera: {
        hash: null,
        camera: false,
      },
      mainSize: {
        height: null,
        width: null,
      },
      colomns: {
        chat: 0,
        project: 0,
        video: 12,
      },
      userName: '',
      requestAuthUsers: {},
      requestAuthUsersLoading: {},
      messageCount: 0,
    };
  },
  destroyed() {
    window.removeEventListener('resize', this.initMainSize);
  },
  async created() {
    try {
      this.id = this.$route.params.id;

      if (this.id) {
        const project = await api.projectMilestones.getById(this.id);
        this.project = project.data;

        this.languages = Object.keys(TRANSLATE_LANGUAGE).map((key) => ({ name: key, value: TRANSLATE_LANGUAGE[key] }));

        this.selectedCamera.hash = this.project.hash;
        this.selectedCamera.camera = false;
      }

      this.meetingId = this.$route.params.meeting;
      // project.hash
      window.addEventListener('resize', this.initMainSize);
    } catch (err) {
      this.showNotification({ type: 'error', message: err.message });
    }
  },
  async mounted() {
    this.initMainSize();
  },
  methods: {
    setMessageCount(messageCount) {
      this.messageCount = messageCount;
    },
    addMessageCount() {
      this.messageCount += 1;
    },
    setRequestAuthUsersLoading(requestAuthUsersLoading) {
      this.requestAuthUsersLoading = requestAuthUsersLoading;
    },
    setRequestAuthUsers(requestAuthUsers) {
      this.requestAuthUsers = requestAuthUsers;
    },
    setConnection(connection) {
      this.connection = connection;
    },
    setIsConnected(isConnected) {
      this.isConnected = isConnected;
    },
    setMeetingHash(meetingHash) {
      this.meetingHash = meetingHash;
    },
    setWaitingForAccess(waitingForAccess) {
      this.waitingForAccess = waitingForAccess;
    },
    async acceptUser(user) {
      if (this.isConnected) {
        this.$set(this.requestAuthUsersLoading, user.email, true);
        this.connection.send(
          JSON.stringify({
            type: this.meetingId ? WS_TYPES.ACCEPT_MEETING_AUTHORIZATION : WS_TYPES.ACCEPT_AUTHORIZATION,
            id: this.meetingId || this.project.id,
            email: user.email,
          })
        );
      }
    },
    async declineUser(user) {
      if (this.isConnected) {
        this.$set(this.requestAuthUsersLoading, user.email, true);
        this.connection.send(
          JSON.stringify({
            type: this.meetingId ? WS_TYPES.DECLINE_MEETING_AUTHORIZATION : WS_TYPES.DECLINE_AUTHORIZATION,
            id: this.meetingId || this.project.id,
            email: user.email,
          })
        );
      }
    },
    zoomProject(value) {
      this.colomns.project += value;
      this.colomns.video -= value;
    },
    triggerWindow(name, amount) {
      if (this.isMobile) {
        Object.keys(this.colomns).map((key) => {
          this.colomns[key] = 0;
        });
        this.colomns[name] = 12;
        return;
      }
      if (this.colomns[name]) {
        this.colomns.video += this.colomns[name];
        this.colomns[name] = 0;
      } else {
        this.colomns[name] = amount;
        this.colomns.video -= amount;
      }
    },
    initMainSize() {
      try {
        const width = window.innerWidth;
        const height = window.innerHeight;
        this.isMobile = width <= 1100;

        if (this.isMobile && this.mainSize && this.mainSize.width !== width) {
          Object.keys(this.colomns).map((key) => {
            this.colomns[key] = 0;
          });
          this.colomns.video = 12;
        }

        const el = window.document.getElementsByClassName('main-camera')[0];
        if (!el) {
          return setTimeout(() => {
            this.initMainSize();
          }, 2000);
        }
        const e = el.getBoundingClientRect();
        this.mainSize = {
          width: e.width,
          height: height,
        };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    selectTwilio(hash) {
      this.initMainSize();
      this.selectedCamera.hash = hash;
      this.selectedCamera.camera = false;

      const el = document.getElementById(hash);
      const mainBlock = document.getElementById('main-camera');
      mainBlock.prepend(el);
    },
    selectCamera(camera) {
      this.initMainSize();
      this.selectedCamera.hash = null;
      this.selectedCamera.camera = camera;

      const el = document.getElementById(this.project.hash);
      const preview = document.getElementById('preview-cameras-block');
      preview.prepend(el);
    },
  },
};
</script>

<style lang="scss">
body {
  overflow: hidden !important;
  height: 100vh !important;
}

.fullSize {
  height: 100%;
  margin: 0;
}

.share-btn {
  height: 40px;
  width: 40px;
  border-radius: 50% !important;
  padding: 0;
  background: linear-gradient(#2260ff, #2260ff) !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-icon {
  background: url('../../../../../../assets/icons/share.svg') no-repeat !important;
  background-position: center;
  height: 20px;
  width: 22px;
}

.cammeras-wrapper {
  padding: 0px !important;
}

.chat-wrapper {
  padding: 0px !important;
  z-index: 1000;
  background: white;
}
.project-wrapper {
  padding: 0px !important;
  z-index: 1000;
  background: white;
}

.camera-stream {
  margin: 5px;
}

.main-camera {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}

.preview-cameras {
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.preview-cameras-block {
  height: 160px;
  display: flex;
  width: 100%;
  overflow: scroll;
  position: absolute;
  z-index: 1000000;
}

.request-user-block {
  background: white;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  width: 100%;
  max-width: 600px;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  height: 73px;
}

.request-user-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}

.request-user-name {
  display: flex;
  align-items: center;
}

.request-user-wrapper {
  position: absolute;
  z-index: 10000;
  width: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.request-loader {
  transform: scale(0.5);
  height: 49px;
  margin-top: -51px;
}

.loading-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>
